<template>
  <section class="app-main">  <breadcrumb class="breadcrumb-container" />  
    <transition name="fade-transform" mode="out-in">
      
      <keep-alive  include="ProjectManageindex,ProcessManageProjectList">
        <router-view :key="key"/>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  name: 'AppMain',
  components: {
    Breadcrumb
  },
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  min-height: calc(100vh - 60px);
  width: calc(100% - 40px);
  margin:0 20px;
  position: relative;
  overflow: hidden;
}
.fixed-header+.app-main {
  padding-top: 60px;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
